import { render, staticRenderFns } from "./bannerModelEditorPopup.vue?vue&type=template&id=4336ff9f&scoped=true&"
import script from "./bannerModelEditorPopup.vue?vue&type=script&lang=js&"
export * from "./bannerModelEditorPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4336ff9f",
  null
  
)

export default component.exports